module.exports = __webpack_public_path__ + "img/Union.862d5e34.svg";